import { request } from "../network/request";
const db = "dn0";


export function xmApplyList(query) {
    return request({
        url: "pmp/xmApply/xmpsList",
        method: "post",
        params:
            query

    });
}

/**
 * 项目评审明细列表导出
 * @param {*} params 
 * @returns 
 */
export function exportPscxList(params) {
    return request({
        url: "pmp/xmApply/xmpsExport",
        method: "get",
        params,
    });
}






